export default __webpack_public_path__ + "static/media/saveCompany.127f5e2e.svg";